module.exports = __webpack_public_path__ + "img/Bingo_Asset_Info_Web_Text2.3d3b31fe.png";